import React from "react";
import PropTypes from "prop-types";
import Row from "../common/Row";
import Form from "../common/Form";
import Fieldset from "../common/Fieldset";
import TextInput from "../common/TextInput";
import Section from "../common/Section";
import * as types from "../../constants/ComponentConstants";

const LoginForm = (props) => {
    const {
        model,
        userLoggedIn,
        disabled,
        onChange,
        onRedirectToOrganisatiePage,
        errors,
        title,
        voornaamHasFocus
    } = props;

    return (
        <Section style={{ margin: '0px', padding: '0px', width: '100%', maxWidth: 'none' }} color={types.COLOR_TURQUOISE_DARK}>
            <Form name="login"
                headerVisible={false}
                isNotRequired
                rightButtonLabel="Ga verder"
                onRightButtonClick={onRedirectToOrganisatiePage}
                rightButtonDisabled={disabled || (!model.naam || !model.voornaam || !model.emailAdres)}
            >
                <Fieldset style={{marginTop:'0px'}}>
                    <Row>
                        <p style={{ 'color': 'rgb(8, 43, 66)', 'fontSize': '1.4375rem', 'fontWeight': '500', 'lineHeight': '28px' }} className="o-col-12" >{title}</p>
                    </Row>
                </Fieldset>
                <Fieldset
                    title="Jouw gegevens"
                    tooltip="Met deze gegevens kunnen we je contacteren met meer informatie over de sportclub."
                    tooltipWindowWidth={30}
                    tooltipWindowAlignRight
                    tooltipColor={types.COLOR_TURQUOISE_DARK}
                >
                    <div style={{ width: "100%", height: "1px", backgroundColor: "#E6E6E6", marginTop: "30px" }}></div>
                    <Row>
                        <TextInput
                            name="voornaam"
                            label="Voornaam"
                            value={model.voornaam}
                            onChange={onChange}
                            disabled={userLoggedIn || disabled}
                            size={6}
                            hasFocus={voornaamHasFocus}
                        />
                        <TextInput
                            name="naam"
                            label="Achternaam"
                            value={model.naam}
                            onChange={onChange}
                            disabled={userLoggedIn || disabled}
                            size={6}
                        />
                    </Row>
                    <Row>
                        <TextInput
                            name="emailAdres"
                            label="E-Mail"
                            value={model.emailAdres}
                            onChange={onChange}
                            disabled={disabled}
                            size={12}
                            tooltip="Het e-mailadres wordt enkel gebruikt om u op de hoogte te brengen van uw voorgestelde wijziging."
                            tooltipColor={types.COLOR_TURQUOISE_DARK}
                            validationMessage={errors['email']}
                        />
                    </Row>
                </Fieldset>
            </Form>
        </Section>
    );
};

LoginForm.propTypes = {
    model: PropTypes.object,
    userLoggedIn: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    onRedirectToOrganisatiePage: PropTypes.func,
    errors: PropTypes.object,
    title: PropTypes.string,
    voornaamHasFocus: PropTypes.bool
};

export default LoginForm;